import { useTranslation } from "react-i18next";

import { Card, Flex, Row, Space, Button } from "antd";
import UserTable from "components/table/UserTable";

import { useState } from "react";
import { useSelector } from "react-redux";
import styles from "../styles/UserManagement.module.css";
import UserListFilter from "./UserListFilter";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import ModalChangePassword from "./ModalChangePassword";

function UserList({
  isLoading = false,
  userList = [],
  supervisorOptions = [],
  supervisorOption = [],
  currentUser = {},
  openEditModal = false,
  roleOptions = [],
  handleEditModalOk = () => { },
  handleEditModalCancel = () => { },
  onCreate = () => { },
  onSearch = () => { },
  onEdit = () => { },
  onCancel = () => { },
  getSupervisorListOption = () => { },
  getModal = () => { },
  onStatus = () => { },
  resetPassword = () => { },
  onChange = () => { },
  pagination = {},
  isModalOpen = false,
  setIsModalOpen = () => { },
  onSubmitChangeModal = () => { },
  onChangePassword = () => { }
}) {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);
  return (
    <>
      {getModal()}

      <ModalChangePassword
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        onSubmitChangeModal={onSubmitChangeModal}
      />

      <Space className={styles.container} direction="vertical" size={24}>
        <Row justify="space-between">
          <div />
          <Space direction="horizontal" size={10}>
            <Button type="default" onClick={() => setUseFilter(!useFilter)}
              style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            {/* {
              roles.includes("CREATE_USER_MANAGEMENT|USER_LIST") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
                type="primary">
                <Flex align="center" justify="center" gap={8}>
                  <CreateIcon />
                  {t("common.create")}
                </Flex>
              </Button>
            } */}
          </Space>
        </Row>
        {useFilter && (
          <Card width="100%" style={{ border: "1px solid #EAECF0", borderRadius: "8px" }}>
            <UserListFilter
              isLoading={isLoading}
              dataSource={userList}
              dataFlag={"userList"}
              supervisorOptions={supervisorOptions}
              roleOptions={roleOptions}
              onEdit={onEdit}
              onSubmit={onSearch}
            />
          </Card>)}
        {/* <CardContainer width="100%" height="839px"> */}
        <UserTable
          isLoading={isLoading}
          dataSource={userList}
          onEdit={onEdit}
          onStatus={onStatus}
          onDelete={onStatus}
          resetPassword={resetPassword}
          onChange={onChange}
          pagination={pagination}
          onChangePassword={onChangePassword}
        />
        {/* </CardContainer> */}
      </Space>
    </>
  );
}

export default UserList;
